import { useEffect } from 'react';
import { healthSchema } from '@xphoto/shared';
import { useAuth } from '../auth/AuthProvider';
import { EMBEDDED_BUILD_ID } from '../pwa/version';
import { registerApp, setUser } from './context';

/**
 * Pont entre l'app et le module de diagnostic : publie l'utilisateur actif (id +
 * rôle, métadonnées) et les informations statiques (version + hôte via
 * `/api/health`, `buildId` du bundle). Ne rend rien.
 *
 * Aucune donnée sensible : ni e-mail, ni nom affiché, seulement l'`id` structurel
 * et le rôle (utile pour reproduire un problème de permissions).
 */
export function DiagnosticsBridge(): null {
  const { user } = useAuth();

  // Utilisateur courant → contexte (recalculé à chaque changement d'identité).
  useEffect(() => {
    setUser(user ? { id: user.id, role: user.role } : null);
  }, [user]);

  // Informations statiques : version + hôte via /api/health (une fois). Le buildId
  // vient du bundle (build client réellement en cours d'exécution).
  useEffect(() => {
    const controller = new AbortController();
    registerApp({ buildId: EMBEDDED_BUILD_ID === 'dev' ? null : EMBEDDED_BUILD_ID });
    fetch('/api/health', { signal: controller.signal })
      .then((r) => r.json())
      .then((data) => {
        const parsed = healthSchema.safeParse(data);
        if (parsed.success) {
          registerApp({ version: parsed.data.version, hostname: parsed.data.publicHostname });
        }
      })
      .catch(() => {
        // Health injoignable : on garde les valeurs par défaut, non bloquant.
      });
    return () => controller.abort();
  }, []);

  return null;
}
